import { gql } from "@apollo/client";

export const INTEGRATION_FIELDS = gql`
  fragment IntegrationFields on Integration {
    id
    name
    service
    createdAt
    updatedAt
    deletedAt
    ... on ActionKitIntegration {
      settings {
        username
        domain
        subscribeSubmissions
        sendWelcomeMessage {
          script
          mediaUpload {
            id
            fileName
            contentType
            publicGetUrl
          }
        }
      }
      metadata {
        webhookConnectedAt
      }
    }
    ... on GCSImportIntegration {
      settings {
        bucketName
      }
    }
    ... on ActBlueWebhookIntegration {
      settings {
        webhookUrl
        subscribeDonors
        sendDonationMessage {
          script
          mediaUpload {
            id
            fileName
            contentType
            publicGetUrl
          }
        }
      }
    }
    ... on ActBlueImportIntegration {
      settings {
        clientUuid
      }
    }
    ... on NgpVanIntegration {
      settings {
        applicationName
        vanMyCampaignContactTypeId
        vanMyVotersContactTypeId
        vanMyCampaignInitialMessageResultCodeId
        vanMyVotersInitialMessageResultCodeId
      }
      metadata {
        vanApiInputTypeId
        databaseName
        committeeName
        keyReference
        hasMyCampaign
        hasMyVoters
        vanMyCampaignContactTypes {
          name
          contactTypeId
        }
        vanMyVotersContactTypes {
          name
          contactTypeId
        }
        vanMyCampaignResultCodes {
          name
          resultCodeId
        }
        vanMyVotersResultCodes {
          name
          resultCodeId
        }
      }
    }
  }
`;

export const NGPVAN_API_KEY_PROFILE_FIELDS = gql`
  fragment NgpVanApiKeyProfileFields on NgpVanValidateApiKeyResponse {
    applicationName
    databaseName
    committeeName
    keyReference
    vanApiInputTypeId
    hasMyCampaign
    vanMyCampaignContactTypeId
    vanMyCampaignInitialMessageResultCodeId
    vanMyCampaignContactTypes {
      name
      contactTypeId
    }
    vanMyCampaignResultCodes {
      name
      resultCodeId
    }
    hasMyVoters
    vanMyVotersContactTypeId
    vanMyVotersContactTypes {
      name
      contactTypeId
    }
    vanMyVotersInitialMessageResultCodeId
    vanMyVotersResultCodes {
      name
      resultCodeId
    }
  }
`;

export const LIST_INTEGRATIONS = gql`
  ${INTEGRATION_FIELDS}
  query ListIntegrations($input: ListIntegrationsInput!) {
    listIntegrations(input: $input) {
      ...IntegrationFields
    }
  }
`;
export const LIST_TENANT_INTEGRATIONS = gql`
  ${INTEGRATION_FIELDS}
  query ListTenantIntegrations($input: ListTenantIntegrationsInput!) {
    listTenantIntegrations(input: $input) {
      ...IntegrationFields
    }
  }
`;

export const CREATE_ACTION_KIT_INTEGRATION = gql`
  ${INTEGRATION_FIELDS}
  mutation CreateActionKitIntegration(
    $input: CreateActionKitIntegrationInput!
  ) {
    createActionKitIntegration(input: $input) {
      ...IntegrationFields
    }
  }
`;

export const UPDATE_ACTION_KIT_INTEGRATION = gql`
  ${INTEGRATION_FIELDS}
  mutation UpdateActionKitIntegration(
    $input: UpdateActionKitIntegrationInput!
  ) {
    updateActionKitIntegration(input: $input) {
      ...IntegrationFields
    }
  }
`;

export const GET_ACTION_KIT_WEBHOOK_URL = gql`
  mutation ActionKitIntegrationGetWebhookUrl(
    $input: ActionKitIntegrationGetWebhookUrlInput!
  ) {
    actionKitIntegrationGetWebhookUrl(input: $input) {
      webhookUrl
    }
  }
`;

export const CREATE_GCS_IMPORT_INTEGRATION = gql`
  ${INTEGRATION_FIELDS}
  mutation CreateGCSImportIntegration(
    $input: CreateGCSImportIntegrationInput!
  ) {
    createGCSImportIntegration(input: $input) {
      ...IntegrationFields
    }
  }
`;

export const UPDATE_GCS_IMPORT_INTEGRATION = gql`
  ${INTEGRATION_FIELDS}
  mutation UpdateGCSImportIntegration(
    $input: UpdateGCSImportIntegrationInput!
  ) {
    updateGCSImportIntegration(input: $input) {
      ...IntegrationFields
    }
  }
`;

export const GET_GCS_IMPORT_FILE_NAME_COMPLETIONS = gql`
  query getGCSImportFileNameCompletions(
    $input: GetGCSImportFileNameCompletionsInput!
  ) {
    getGCSImportFileNameCompletions(input: $input)
  }
`;

export const GET_GCS_IMPORT_FILE_HEADERS = gql`
  query getGCSImportFileHeaders($input: GetGCSImportFileHeadersInput!) {
    getGCSImportFileHeaders(input: $input)
  }
`;

export const CREATE_ACT_BLUE_WEBHOOK_INTEGRATION = gql`
  mutation CreateActBlueWebhookIntegration(
    $input: CreateActBlueWebhookIntegrationInput!
  ) {
    createActBlueWebhookIntegration(input: $input) {
      username
      password
      webhookUrl
      subscribeDonors
      sendDonationMessage {
        script
        mediaUpload {
          id
          fileName
          contentType
          publicGetUrl
        }
      }
    }
  }
`;

export const UPDATE_ACT_BLUE_WEBHOOK_INTEGRATION = gql`
  ${INTEGRATION_FIELDS}
  mutation UpdateActBlueWebhookIntegration(
    $input: UpdateActBlueWebhookIntegrationInput!
  ) {
    updateActBlueWebhookIntegration(input: $input) {
      ...IntegrationFields
    }
  }
`;

export const CREATE_ACT_BLUE_IMPORT_INTEGRATION = gql`
  ${INTEGRATION_FIELDS}
  mutation CreateActBlueImportIntegration(
    $input: CreateActBlueImportIntegrationInput!
  ) {
    createActBlueImportIntegration(input: $input) {
      ...IntegrationFields
    }
  }
`;

export const UPDATE_ACT_BLUE_IMPORT_INTEGRATION = gql`
  ${INTEGRATION_FIELDS}
  mutation UpdateActBlueImportIntegration(
    $input: UpdateActBlueImportIntegrationInput!
  ) {
    updateActBlueImportIntegration(input: $input) {
      ...IntegrationFields
    }
  }
`;

export const VALIDATE_NGPVAN_INTEGRATION = gql`
  ${NGPVAN_API_KEY_PROFILE_FIELDS}
  mutation ValidateNgpVanIntegration($input: ValidateNgpVanIntegrationInput!) {
    validateNgpVanIntegration(input: $input) {
      ...NgpVanApiKeyProfileFields
    }
  }
`;

export const FETCH_NGPVAN_ITEGRATION_METADATA = gql`
  query FetchNgpVanApiKeyProfile($input: FetchNgpVanIntegrationMetadataInput!) {
    fetchNgpVanIntegrationMetadata(input: $input) {
      vanApiInputTypeId
      databaseName
      committeeName
      keyReference
      hasMyCampaign
      hasMyVoters
      vanMyCampaignContactTypes {
        name
        contactTypeId
      }
      vanMyVotersContactTypes {
        name
        contactTypeId
      }
      vanMyCampaignResultCodes {
        name
        resultCodeId
      }
      vanMyVotersResultCodes {
        name
        resultCodeId
      }
    }
  }
`;

const NGPVAN_OBJECT_REFRESH_JOB_FIELDS = gql`
  fragment NgpVanObjectRefreshJobFields on NgpVanObjectRefreshJob {
    id
    status
    errorMessage
    startedAt
    result {
      nObjects
    }
  }
`;

const NGPVAN_INTEGRATION_FIELDS = gql`
  ${NGPVAN_OBJECT_REFRESH_JOB_FIELDS}

  fragment NgpVanIntegrationFields on NgpVanIntegration {
    id

    ngpVanMyCampaignSurveyQuestionRefreshJob {
      ...NgpVanObjectRefreshJobFields
    }
    ngpVanMyCampaignSurveyQuestionLastRefresh
    ngpVanMyCampaignActivistCodeRefreshJob {
      ...NgpVanObjectRefreshJobFields
    }
    ngpVanMyCampaignActivistCodeLastRefresh
    ngpVanMyCampaignSavedListRefreshJob {
      ...NgpVanObjectRefreshJobFields
    }
    ngpVanMyCampaignSavedListLastRefresh

    ngpVanMyVotersSurveyQuestionRefreshJob {
      ...NgpVanObjectRefreshJobFields
    }
    ngpVanMyVotersSurveyQuestionLastRefresh
    ngpVanMyVotersActivistCodeRefreshJob {
      ...NgpVanObjectRefreshJobFields
    }
    ngpVanMyVotersActivistCodeLastRefresh
    ngpVanMyVotersSavedListRefreshJob {
      ...NgpVanObjectRefreshJobFields
    }
    ngpVanMyVotersSavedListLastRefresh
  }
`;

export const GET_NGPVAN_INTEGRATION = gql`
  ${NGPVAN_INTEGRATION_FIELDS}

  query GetNgpVanIntegration($input: GetNgpVanIntegrationInput!) {
    getNgpVanIntegration(input: $input) {
      ...NgpVanIntegrationFields
    }
  }
`;

export const GET_NGPVAN_REFRESH_JOB = gql`
  ${NGPVAN_OBJECT_REFRESH_JOB_FIELDS}
  query GetNgpVanObjectRefreshJob($input: GetNgpVanObjectRefreshJobInput!) {
    getNgpVanObjectRefreshJob(input: $input) {
      ...NgpVanObjectRefreshJobFields
    }
  }
`;

export const NGPVAN_SAVED_LIST_FIELDS = gql`
  fragment NgpVanSavedListFields on NgpVanSavedLists {
    id
    integrationId
    databaseMode
    savedListId
    name
    description
    listCount
    createdAt
  }
`;

export const GET_NGPVAN_SAVED_LIST = gql`
  ${NGPVAN_SAVED_LIST_FIELDS}
  query GetNgpVanSavedList($input: GetNgpVanSavedListInput!) {
    getNgpVanSavedList(input: $input) {
      ...NgpVanSavedListFields
    }
  }
`;

export const GET_NGPVAN_SAVED_LISTS = gql`
  ${NGPVAN_SAVED_LIST_FIELDS}
  query GetNgpVanSavedLists($input: GetNgpVanSavedListsInput!) {
    getNgpVanSavedLists(input: $input) {
      ...NgpVanSavedListFields
    }
  }
`;

export const NGPVAN_ACTIVIST_CODE_FIELDS = gql`
  fragment NgpVanActivistCodeFields on NgpVanActivistCode {
    id
    integrationId
    databaseMode
    activistCodeId
    name
    description
  }
`;

export const GET_NGPVAN_ACTIVIST_CODE = gql`
  ${NGPVAN_ACTIVIST_CODE_FIELDS}
  query GetNgpVanActivistCode($input: GetNgpVanActivistCodeInput!) {
    getNgpVanActivistCode(input: $input) {
      ...NgpVanActivistCodeFields
    }
  }
`;

export const GET_NGPVAN_ACTIVIST_CODES = gql`
  ${NGPVAN_ACTIVIST_CODE_FIELDS}
  query GetNgpVanActivistCodes($input: GetNgpVanActivistCodesInput!) {
    getNgpVanActivistCodes(input: $input) {
      ...NgpVanActivistCodeFields
    }
  }
`;

export const NGPVAN_SURVEY_QUESTION_FIELDS = gql`
  fragment NgpVanSurveyQuestionFields on NgpVanSurveyQuestion {
    id
    integrationId
    databaseMode
    surveyQuestionId
    name
    scriptQuestion
  }
`;

export const GET_NGPVAN_SURVEY_QUESTION_WITH_RESPONSES = gql`
  ${NGPVAN_SURVEY_QUESTION_FIELDS}
  query GetNgpVanSurveyQuestionWithResponses(
    $input: GetNgpVanSurveyQuestionInput!
  ) {
    getNgpVanSurveyQuestion(input: $input) {
      ...NgpVanSurveyQuestionFields
      responses {
        name
        surveyResponseId
      }
    }
  }
`;

export const GET_NGPVAN_SURVEY_QUESTION = gql`
  ${NGPVAN_SURVEY_QUESTION_FIELDS}
  query GetNgpVanSurveyQuestion($input: GetNgpVanSurveyQuestionInput!) {
    getNgpVanSurveyQuestion(input: $input) {
      ...NgpVanSurveyQuestionFields
    }
  }
`;

export const GET_NGPVAN_SURVEY_QUESTIONS = gql`
  ${NGPVAN_SURVEY_QUESTION_FIELDS}
  query GetNgpVanSurveyQuestions($input: GetNgpVanSurveyQuestionsInput!) {
    getNgpVanSurveyQuestions(input: $input) {
      ...NgpVanSurveyQuestionFields
    }
  }
`;

export const REFRESH_NGPVAN_OBJECTS = gql`
  ${NGPVAN_INTEGRATION_FIELDS}
  mutation RefreshNgpVanObjects($input: RefreshNgpVanObjectsInput!) {
    refreshNgpVanObjects(input: $input) {
      ...NgpVanIntegrationFields
    }
  }
`;
export const CREATE_NGPVAN_INTEGRATION = gql`
  ${INTEGRATION_FIELDS}
  mutation CreateNgpVanIntegration($input: CreateNgpVanIntegrationInput!) {
    createNgpVanIntegration(input: $input) {
      ...IntegrationFields
    }
  }
`;
export const UPDATE_NGPVAN_INTEGRATION = gql`
  ${INTEGRATION_FIELDS}
  mutation UpdateNgpVanIntegration($input: UpdateNgpVanIntegrationInput!) {
    updateNgpVanIntegration(input: $input) {
      ...IntegrationFields
    }
  }
`;

export const DELETE_INTEGRATION = gql`
  mutation DeleteIntegration($input: DeleteIntegrationInput!) {
    deleteIntegration(input: $input)
  }
`;

export const GET_LATEST_ACTION_KIT_SUBMISSION = gql`
  query GetLatestActionKitSubmission(
    $input: GetLatestActionKitSubmissionInput!
  ) {
    getLatestActionKitSubmission(input: $input) {
      updatedAt
      pageName
    }
  }
`;

export const SIMULATE_DONATIONS = gql`
  mutation SimulateDonations($input: SimulateDonationsInput!) {
    simulateDonations(input: $input) {
      success
      simulatedCount
      errors
      warnings
      message
    }
  }
`;

export const IMPORT_ACT_BLUE_DONATION_HISTORY = gql`
  mutation ImportActBlueDonationHistory(
    $input: ImportActBlueDonationHistoryInput!
  ) {
    importActBlueDonationHistory(input: $input)
  }
`;

export const GET_ACT_BLUE_DONATION_HISTORY_IMPORTS = gql`
  query GetActBlueDonationHistoryImports(
    $input: GetActBlueDonationHistoryImportsInput!
  ) {
    getActBlueDonationHistoryImports(input: $input) {
      id
      status
      args {
        integration {
          id
          name
        }
        startDate
        endDate
      }
      result {
        nRecordsImported
      }
    }
  }
`;
